import { ExpertSlider } from '@/components/ExpertSlider';
import { LabradorComponent } from '@/types/component';

export const LabradorExpertSlider: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <ExpertSlider {...props} />;
};
